import { render, staticRenderFns } from "./SelectDocument.vue?vue&type=template&id=44200740&scoped=true"
import script from "./SelectDocument.vue?vue&type=script&lang=js"
export * from "./SelectDocument.vue?vue&type=script&lang=js"
import style0 from "./SelectDocument.vue?vue&type=style&index=0&id=44200740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44200740",
  null
  
)

export default component.exports